/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropRosterCampaignWindow
 */
export interface DropRosterCampaignWindow {
    /**
     * 
     * @type {string}
     * @memberof DropRosterCampaignWindow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterCampaignWindow
     */
    marker: string;
    /**
     * 
     * @type {string}
     * @memberof DropRosterCampaignWindow
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof DropRosterCampaignWindow
     */
    endsAt: number;
    /**
     * Members currently matched BY this window (campaign marker) rather than by category or telemetry.
     * @type {number}
     * @memberof DropRosterCampaignWindow
     */
    carryingNow: number;
}

/**
 * Check if a given object implements the DropRosterCampaignWindow interface.
 */
export function instanceOfDropRosterCampaignWindow(value: object): value is DropRosterCampaignWindow {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('marker' in value) || value['marker'] === undefined) return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined) return false;
    if (!('carryingNow' in value) || value['carryingNow'] === undefined) return false;
    return true;
}

export function DropRosterCampaignWindowFromJSON(json: any): DropRosterCampaignWindow {
    return DropRosterCampaignWindowFromJSONTyped(json, false);
}

export function DropRosterCampaignWindowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropRosterCampaignWindow {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'marker': json['marker'],
        'label': json['label'] == null ? undefined : json['label'],
        'endsAt': json['endsAt'],
        'carryingNow': json['carryingNow'],
    };
}

export function DropRosterCampaignWindowToJSON(json: any): DropRosterCampaignWindow {
    return DropRosterCampaignWindowToJSONTyped(json, false);
}

export function DropRosterCampaignWindowToJSONTyped(value?: DropRosterCampaignWindow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'marker': value['marker'],
        'label': value['label'],
        'endsAt': value['endsAt'],
        'carryingNow': value['carryingNow'],
    };
}

